import { NavLink } from "react-router-dom";
import "../CSS/header.css"
import { FaMagnifyingGlass } from "react-icons/fa6";
import { IoPersonOutline } from "react-icons/io5";
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from "react";
import { Popover, ArrowContainer } from "react-tiny-popover";
import { login, logout } from "../reducers/loginReducers";
import UserPanel from "./UserPanel";
import { useNavigate } from "react-router-dom";


const Header = () => {

    const loginInfo = useSelector((state) => state.login);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const navigate = useNavigate()

    useEffect(() => {
        console.log("head log", loginInfo)
    }, [loginInfo])

    useEffect(() => {
        if (localStorage.getItem('infinity_user')) {
            console.log("user prsent in local storage")
            dispatch(login(JSON.parse(localStorage.getItem('infinity_user'))));
        }
    }, [])

    const dispatch = useDispatch();

    useEffect(() => {
        if (document.getElementById("react-tiny-popover-container")) {
            document.getElementById("react-tiny-popover-container").className = "popover-content"
        }
    })

    const onLogout = async () => {
        dispatch(logout());
        localStorage.removeItem("infinity_user")
        if (window.location.toString().includes("/my") || window.location.toString().includes("/user") || window.location.toString().includes("/course")) {
            navigate("/")
        }
    }

    return (
        <div className="sticky">
            <div className="red-strip" ></div>
            <div className="main-header row">
                <NavLink to="/" className={({ isActive }) =>
                    (isActive ? 'header-buttons col is-active' : '')

                }><img src="/logo-removebg-preview.png" height="80vh"></img></NavLink>&emsp;
                <div className="vertical-line"></div>
                <NavLink to="/" className={({ isActive }) =>
                    (isActive ? 'header-buttons col is-active' : 'header-buttons col')
                }><b>HOME</b></NavLink>
                <NavLink to="/courses" className={({ isActive }) =>
                    (isActive ? 'header-buttons col is-active' : 'header-buttons col')
                }><b>COURSES</b></NavLink>
                <NavLink to="/contactus" className={({ isActive }) =>
                    (isActive ? 'header-buttons col is-active' : 'header-buttons col')
                }><b>CONTACT US</b></NavLink>
                <NavLink to="/aboutus" className={({ isActive }) =>
                    (isActive ? 'header-buttons col is-active' : 'header-buttons col')
                }><b>ABOUT US</b></NavLink>
                {!loginInfo.username ?
                    <div className="row col login">
                        <IoPersonOutline />
                        <NavLink to="/login" className={({ isActive }) =>
                            (isActive ? 'header-buttons is-active' : 'header-buttons ')
                        }> <b>LOGIN/REGISTER</b></NavLink>
                    </div> :
                    <div className="row col login">
                        {/* <div className="header-buttons"><b>WELCOME, {loginInfo.username.toUpperCase()}</b></div> */}


                        <Popover
                            isOpen={isPopoverOpen}
                            positions={["bottom", "top", "right", "left"]}
                            align="start"
                            padding={8}
                            onClickOutside={() => setIsPopoverOpen(false)}
                            className="popover"
                            content={({ position, childRect, popoverRect }) => (
                                <ArrowContainer
                                    position={position}
                                    childRect={childRect}
                                    popoverRect={popoverRect}
                                    arrowColor={"rgba(186, 32, 32, 0.998)"}
                                    arrowSize={7}
                                >
                                    <UserPanel />
                                </ArrowContainer>
                            )}
                        >
                            <a className="header-buttons"
                                onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                            >
                                <b>WELCOME, {loginInfo.username.toUpperCase()}</b>
                            </a>
                        </Popover>


                        <div className="vertical-line"></div>
                        <a className="header-buttons" onClick={onLogout}><b>LOG OUT</b></a>
                    </div>
                }
                {window.location.toString().includes("/hope.") &&
                    <div className="row">
                        <div className="vertical-line"></div>
                        <a href="https://hopefoundation.org.in" target="_blank" className="header-buttons col"><img src="https://hopefoundation.org.in/wp-content/uploads/2022/11/Header-logo.jpg" height="50vh"></img></a>
                    </div>
                }
            </div>
        </div>
    )
}

export default Header;